import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import {
  FaBoxOpen,
  FaWarehouse,
  FaShippingFast,
  FaTruck,
  FaCheckCircle,
  FaCalendarAlt,
  FaClipboardList
} from "react-icons/fa";

const API_HOST = process.env.REACT_APP_API_URL;

function Seguimiento() {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [packageStatus, setPackageStatus] = useState(null);
  const [origen, setOrigen] = useState("(MIAMI)");

  const styles = {
    background: {
      background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
      minHeight: "100vh",
      padding: "2rem 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    card: {
      border: "none",
      borderRadius: "20px",
      boxShadow: "0 15px 40px rgba(0, 0, 0, 0.3)",
      overflow: "hidden",
      width: "90%",
      maxWidth: "90%",
      margin: "2rem auto",
      backgroundColor: "#ffffff",
      transition: "all 0.3s ease",
    },
    cardHeader: {
      background: "#3a5a8a",
      color: "white",
      padding: "1.5rem",
      marginBottom: "1.5rem",
      borderBottom: "3px solid #2c4365",
      borderRadius: "20px 20px 0 0",
      textAlign: "center",
    },
    trackingInput: {
      borderRadius: "10px",
      padding: "12px 15px",
      fontSize: "1rem",
    },
    searchButton: {
      borderRadius: "10px",
      padding: "12px 25px",
      fontWeight: "600",
      fontSize: "1rem",
    },
    progressBar: {
      height: "8px",
      borderRadius: "4px",
      backgroundColor: "#e9ecef",
      margin: "2rem 0",
      overflow: "hidden",
      position: "relative",
    },
    progressStep: {
      height: "100%",
      transition: "width 0.6s ease",
    },
    statusCard: {
      borderLeft: "4px solid",
      padding: "1.5rem",
      marginBottom: "1rem",
      borderRadius: "8px",
      backgroundColor: "white",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      transition: "all 0.3s ease",
      position: "relative",
    },
    statusIcon: {
      width: "60px",
      height: "60px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "1rem",
    },
  };

  const statuses = [
    {
      id: 1,
      title: "En espera",
      description: "Tu paquete aún no ha llegado a nuestras bodegas",
      icon: <FaBoxOpen size={30} />,
      color: "#6c757d",
    },
    {
      id: 2,
      title: "En bodega" + origen,
      description: "Hemos recibido tu paquete en nuestras instalaciones",
      icon: <FaWarehouse size={30} />,
      color: "#17a2b8",
    },
    {
      id: 3,
      title: "En tránsito",
      description: "Tu paquete está en camino a Honduras",
      icon: <FaShippingFast size={30} />,
      color: "#ffc107",
    },
    {
      id: 4,
      title: "Listo para entrega",
      description: "Tu paquete ha llegado y está listo para ser entregado",
      icon: <FaTruck size={30} />,
      color: "#28a745",
    },
    {
      id: 5,
      title: "Entregado",
      description: "¡Paquete entregado satisfactoriamente!",
      icon: <FaCheckCircle size={30} />,
      color: "#6610f2",
    },
  ];

  // Configuración de los 4 estados exactos para la tarjeta de Reempaque
  const reempaqueConfig = {
    'Pendiente': { 
      title: "Solicitud Pendiente", 
      description: "Faltan agregar más paquetes a esta solicitud.", 
      color: "#ffc107", 
      icon: <FaBoxOpen /> 
    },
    'Completada': { 
      title: "Solicitud Completada", 
      description: "Ya se agregaron los paquetes. Lista para ser aceptada o rechazada.", 
      color: "#17a2b8", 
      icon: <FaClipboardList /> 
    },
    'Aprobada': { 
      title: "Solicitud Aprobada", 
      description: "Tu solicitud ha sido aceptada y procesada exitosamente.", 
      color: "#28a745", 
      icon: <FaCheckCircle /> 
    },
    'Denegada': { 
      title: "Solicitud Rechazada", 
      description: "Tu solicitud ha sido rechazada o denegada.", 
      color: "#dc3545", 
      icon: <FaBoxOpen /> 
    }
  };

  const checkPackageStatus = async () => {
    if (trackingNumber.trim() === "") {
      Swal.fire({
        title: "Número requerido",
        text: "Por favor ingresa un número de tracking válido",
        icon: "warning",
        confirmButtonColor: "#3a5a8a",
      });
      return;
    }

    try {
      Swal.fire({
        title: "Buscando paquete",
        text: "Por favor espera...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await fetch(
        `${API_HOST}/paquetes/public/${trackingNumber}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            API: "457896",
          },
        }
      );

      if (!response.ok) {
        throw new Error("No se encontró el paquete o no existe estado configurado.");
      }

      const data = await response.json();
      
      const estadoReal = data.estado; // Ej: "En proceso de reempaque(Pendiente)"
      const estadoLower = estadoReal.toLowerCase();
      let fechaHonduras = null;

      if (data.fechaHonduras) {
        fechaHonduras = new Date(data.fechaHonduras).toLocaleDateString('es-HN', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      }

      // 1. Identificar en qué paso de la línea de tiempo está (del 1 al 5)
      let stepId = 1;
      if (estadoLower.includes("espera")) {
        stepId = 1;
      } else if (estadoLower.includes("bodega") || estadoLower.includes("reempaque")) {
        stepId = 2; // El reempaque ocurre físicamente en bodega
      } else if (estadoLower.includes("tránsito") || estadoLower.includes("transito")) {
        stepId = 3;
      } else if ((estadoLower.includes("listo") || estadoLower.includes("entrega")) && !estadoLower.includes("entregado")) {
        stepId = 4;
      } else if (estadoLower.includes("entregado")) {
        stepId = 5;
      }

      // 2. Establecer el Origen si está en bodega o reempaque
      if (estadoLower.includes("miami") || estadoLower.includes("reempaque")) {
        setOrigen(" (MIAMI)");
      } else if (estadoLower.includes("méxico") || estadoLower.includes("mexico")) {
        setOrigen(" (MÉXICO)");
      }

      const estadoBase = statuses.find(s => s.id === stepId);

      if (!estadoBase) {
        throw new Error("Estado del paquete no reconocido");
      }

      Swal.close();
      
      // 3. Guardar el estado unificado
      setPackageStatus({
        ...estadoBase,
        estadoDisplay: estadoReal, // Mantener el texto exacto de la base de datos para mostrar
        fechaHonduras,
        solicitudReempaque: data.solicitudReempaque || null
      });

    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error.message || "No se pudo encontrar el paquete",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      setPackageStatus(null);
    }
  };

  // Variable de apoyo para renderizar los datos correctos de la solicitud
  const reempaqueUI = packageStatus?.solicitudReempaque 
    ? reempaqueConfig[packageStatus.solicitudReempaque.estado] || reempaqueConfig['Pendiente']
    : null;

  return (
    <div style={styles.background}>
      <Card style={styles.card}>
        <div style={styles.cardHeader}>
          <h3 className='text-center mb-0'>Seguimiento de Paquetes</h3>
        </div>
        <Card.Body className='p-4'>
          <Form.Group className='mb-4'>
            <Form.Label className='fw-bold'>Número de Tracking</Form.Label>
            <div className='d-flex gap-2'>
              <Form.Control
                type='text'
                placeholder='Ingresa tu número de seguimiento'
                value={trackingNumber}
                onChange={(e) => setTrackingNumber(e.target.value)}
                className='py-2'
                style={styles.trackingInput}
              />
              <Button
                variant='primary'
                onClick={checkPackageStatus}
                style={styles.searchButton}
              >
                Buscar
              </Button>
            </div>
            <Form.Text className='text-muted'>Ejemplo: 123456789</Form.Text>
          </Form.Group>

          {packageStatus && (
            <div className='mt-4'>
              {/* === Sección destacada del ESTADO ACTUAL === */}
              <div
                className='p-4 mb-4 text-center rounded'
                style={{
                  backgroundColor: `${packageStatus.color}15`,
                  border: `2px solid ${packageStatus.color}`,
                  position: "relative",
                  overflow: "hidden",
                  animation: "highlight-pulse 2s infinite",
                }}
              >
                <div className='d-flex justify-content-center align-items-center mb-3'>
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      borderRadius: "50%",
                      backgroundColor: `${packageStatus.color}30`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "15px",
                      animation: "pulse 2s infinite",
                    }}
                  >
                    {packageStatus.icon}
                  </div>
                  <div className='text-start'>
                    <h4 className='mb-1' style={{ color: packageStatus.color }}>
                      {/* Aquí se imprime el texto original de la BD (Ej: "En proceso de reempaque(Pendiente)") */}
                      <strong>Estado actual: {packageStatus.estadoDisplay}</strong>
                    </h4>
                    <p className='mb-0'>{packageStatus.description}</p>
                  </div>
                </div>
              </div>

              {/* === TARJETA OPCIONAL DE SOLICITUD DE REEMPAQUE === */}
              {packageStatus.solicitudReempaque && reempaqueUI && (
                <Card className="mb-4 shadow-sm" style={{ borderLeft: `6px solid ${reempaqueUI.color}` }}>
                  <Card.Body>
                    <div className="d-flex align-items-center mb-2">
                      <div className="me-3" style={{ color: reempaqueUI.color }}>
                        {reempaqueUI.icon}
                      </div>
                      <h5 className="mb-0 fw-bold">Gestión de Reempaque: {packageStatus.solicitudReempaque.estado}</h5>
                    </div>
                    <p className="text-muted ms-5 mb-0">
                      {reempaqueUI.description}
                    </p>
                  </Card.Body>
                </Card>
              )}

              {/* Sección de fecha probable de llegada */}
              {packageStatus.fechaHonduras && (
                <div className='mb-4 p-3 rounded d-flex align-items-center justify-content-center' 
                     style={{
                       backgroundColor: '#f0f7ff',
                       border: '1px solid #cce0ff',
                       borderRadius: '8px',
                       padding: '15px',
                       marginBottom: '20px'
                     }}>
                  <FaCalendarAlt className='me-3' style={{ color: '#3a5a8a', fontSize: '1.5rem' }} />
                  <div>
                    <h5 style={{ color: '#3a5a8a', marginBottom: '5px' }}>
                      Fecha probable de llegada a Honduras:
                    </h5>
                    <p className='mb-0 fw-bold' style={{ color: '#2c3e50', fontSize: '1.2rem' }}>
                      {packageStatus.fechaHonduras}
                    </p>
                  </div>
                </div>
              )}

              {/* Barra de progreso mejorada */}
              <div className='position-relative mb-4'>
                <div style={styles.progressBar}>
                  <div
                    style={{
                      ...styles.progressStep,
                      width: `${
                        ((packageStatus.id - 1) / (statuses.length - 1)) * 100
                      }%`,
                      backgroundColor: packageStatus.color,
                      boxShadow: `0 0 15px ${packageStatus.color}`,
                    }}
                  ></div>
                </div>
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: `${
                      ((packageStatus.id - 1) / (statuses.length - 1)) * 100
                    }%`,
                    transform: "translateX(-50%)",
                    width: "25px",
                    height: "25px",
                    borderRadius: "50%",
                    backgroundColor: packageStatus.color,
                    border: `3px solid white`,
                    boxShadow: `0 0 0 3px ${packageStatus.color}`,
                  }}
                ></div>
              </div>

              {/* Lista de estados */}
              <div className='row'>
                {statuses.map((status) => (
                  <div className='col-md-6 mb-3' key={status.id}>
                    <div
                      style={{
                        ...styles.statusCard,
                        borderLeftColor: status.color,
                        opacity: packageStatus.id >= status.id ? 1 : 0.6,
                        transform:
                          packageStatus.id === status.id
                            ? "scale(1.05)"
                            : "scale(1)",
                        boxShadow:
                          packageStatus.id === status.id
                            ? `0 5px 20px ${status.color}40`
                            : "0 4px 12px rgba(0,0,0,0.1)",
                        border:
                          packageStatus.id === status.id
                            ? `2px solid ${status.color}`
                            : "none",
                      }}
                      className='status-card'
                    >
                      {packageStatus.id === status.id && (
                        <div className='position-absolute top-0 start-0 p-2'>
                          <div
                            style={{
                              width: "15px",
                              height: "15px",
                              borderRadius: "50%",
                              backgroundColor: status.color,
                              boxShadow: `0 0 10px ${status.color}`,
                            }}
                          ></div>
                        </div>
                      )}

                      <div
                        style={{
                          ...styles.statusIcon,
                          backgroundColor: `${status.color}20`,
                          color: status.color,
                          animation:
                            packageStatus.id === status.id
                              ? "pulse 2s infinite"
                              : "none",
                        }}
                      >
                        {status.icon}
                      </div>
                      <h5 style={{ color: status.color }}>{status.title}</h5>
                      <p className='mb-0'>{status.description}</p>
                      {packageStatus.id === status.id && (
                        <div className='mt-2'>
                          <small className='text-muted'>Paso actual</small>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {!packageStatus && (
            <div className='text-center py-4'>
              <FaBoxOpen size={60} color='#6c757d' className='mb-3' />
              <h5>Ingresa tu número de tracking</h5>
              <p className='text-muted'>
                Consulta el estado actual de tu paquete en cualquier momento
              </p>
            </div>
          )}
        </Card.Body>
      </Card>

      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.05); }
            100% { transform: scale(1); }
          }
          @keyframes highlight-pulse {
            0% { box-shadow: 0 0 0 0 ${packageStatus?.color || "#3a5a8a"}80; }
            70% { box-shadow: 0 0 0 10px ${
              packageStatus?.color || "#3a5a8a"
            }00; }
            100% { box-shadow: 0 0 0 0 ${packageStatus?.color || "#3a5a8a"}00; }
          }
          .status-card:hover {
            transform: translateY(-5px) !important;
            box-shadow: 0 10px 20px rgba(0,0,0,0.15) !important;
          }
        `}
      </style>
    </div>
  );
}

export default Seguimiento;